import React from 'react'

import Overview from './Overview'
import './style.css'

const content1 = require('./content1.jpg')
const content2 = require('./graph.jpg')
const content3 = require('./graph1.jpg')


export default class DashboardSolo extends React.Component {
  state = {
    display: NaN as number,
  }

  displayOverview = () => this.setState({display: NaN})
  displayWorker = n => this.setState({display: n})

  render() {
    let content

    switch (this.state.display) {
      case 0:
      case 1:
      case 2:
        content = <Worker/>
        break

      default:
        content = <Overview/>
    }

    return ( /* eslint-disable max-len */
      <>
      <Sidebar active={this.state.display} onOverview={this.displayOverview} onWorker={this.displayWorker}/>

      <div style={{marginLeft: 45}}>
        <div className="isoLayoutContentWrapper solo-dashboard">

          <div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24" style={{paddingLeft: 8, paddingRight: 8, marginBottom: 16}}>
            <div className="isoBoxWrapper sc-chPdSV cOTLJI">
              <div>
                <h3 className="isoBoxTitle sc-cSHVUG ifvfLf"> INFO </h3>
                <p className="isoBoxSubTitle sc-kAzzGY gCwUWQ">
                  Veškeré zobrazitelné informace k jednotlivým balíčkům jsou vidět na stránce <b>Dashboard</b> v sekcích <b>My Workers</b> nahoře a dole v sekci <b>Raw data / Purchase</b>.
                </p>
              </div>
            </div>
          </div>

          <h1 className="isoComponentTitle sc-jzJRlG kviPuT">Overview</h1>

          {content}

        </div>
      </div>
      </>
    )
  }
}

const Worker = () => (
  <>
    <img src={content1} width={1012}/>
    <img src={content2} width={617} />
    <img src={content3} width={394} />
  </>
)

const Sidebar = ({active, onOverview, onWorker}) => (
  <div className="fixed-sidebar-left">
    <div className="slimScrollDiv" style={{position: 'relative', overflow: 'hidden', width: 'auto', height: '100%'}}>
      <ul className="nav navbar-nav side-nav nicescroll-bar" style={{overflow: 'hidden', width: 'auto', height: '100%'}}>

        <li style={{height: 100}}/>

        <li>
          <a onClick={onOverview}>
            <div className="pull-left">
              <span style={{display: 'inline-flex', width: 45}}>
                <span className="icon" style={{margin: 'auto'}}>
                  <i className="ion-speedometer"/>
                </span>
              </span>
              <span className="right-nav-text">Overview</span>
            </div>
            <div className="pull-right">
              <i className="ion-android-arrow-dropdown"/>
            </div>
            <div className="clearfix"/>
          </a>
          <ul id="ui_dr" className="collapse collapse-level-1 two-col-list">
            <li><span className="sub">Total Gain: Ξ 0 ETH</span></li>
            <li><span className="sub">Balance: Ξ 0.5 ETH</span></li>
          </ul>
        </li>

        <li><hr className="light-grey-hr mb-10"/></li>

        <li className="navigation-header">
          <span>Active Workers</span>
          <i className="ion-more"/>
        </li>

        <li>
          <a onClick={() => onWorker(0)} className={(active === 0) ? 'active-page' : ''}>
            <div className="pull-left">
              <span style={{display: 'inline-flex', width: 45}}>
                <span className="icon" style={{margin: 'auto'}}>120</span>
              </span>
              <span className="right-nav-text">
                <span className="mhs">MH/s</span>
                <span className="summary">
                  <i className="ion-arrow-graph-up-right"/> Ξ0.0444
                  <span style={{paddingLeft: 15}}/>
                  <i className="ion-cash"/> €100
                </span>
              </span>
            </div>
            <div className="clearfix"/>
          </a>
        </li>

        <li>
          <a onClick={() => onWorker(1)} className={(active === 1) ? 'active-page' : ''}>
            <div className="pull-left">
              <span style={{display: 'inline-flex', width: 45}}>
                <span className="icon" style={{margin: 'auto'}}>80</span>
              </span>
              <span className="right-nav-text">
                <span className="mhs">MH/s</span>
                <span className="summary">
                  <i className="ion-arrow-graph-up-right"/> Ξ0.0224
                  <span style={{paddingLeft: 15}}/>
                  <i className="ion-cash"/> €20
                </span>
              </span>
            </div>
            <div className="clearfix"/>
          </a>
        </li>

        <li className="navigation-header expired-workers">
          <span>Expired Workers</span>
          <i className="ion-more"/>
        </li>

        <li>
          <a onClick={() => onWorker(2)} className={(active === 2) ? 'active-page' : ''}>
            <div className="pull-left">
              <span style={{display: 'inline-flex', width: 45}}>
                <span className="icon" style={{margin: 'auto'}}>{' 40 '}</span>
              </span>
              <span className="right-nav-text">
                <span className="mhs">MH/s</span>
                <span className="summary">
                  <i className="ion-arrow-graph-up-right"/> Ξ3.0101
                  <span style={{paddingLeft: 15}}/>
                  <i className="ion-cash"/> €0
                </span>
              </span>
            </div>
            <div className="clearfix"/>
          </a>
        </li>

      </ul>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/DashboardSolo/index.tsx